import { createContext, useContext } from 'react';
import { CampaignMapping } from 'src/api/campaignMappings';

export type CampaignMappingsDataContextType = {
  // Data
  campaignMappingsData: CampaignMapping[];
  columns: string[];
  // Loading states
  isLoadingCampaignMappings: boolean;
  isErrorCampaignMappings: boolean;
};

export const CampaignMappingsDataContext =
  createContext<CampaignMappingsDataContextType>({
    campaignMappingsData: [],
    columns: [],
    isLoadingCampaignMappings: false,
    isErrorCampaignMappings: false,
  });

export const useCampaignMappingsDataContext = () => {
  const context = useContext(CampaignMappingsDataContext);
  if (!context) {
    throw new Error(
      'useCampaignMappingsDataContext must be used within a CampaignMappingsDataContextProvider',
    );
  }
  return context;
};
